import { useTranslation } from "react-i18next"
import HeaderLabel from "../headerLabel"
import { ProcedureSectionWrapper } from "./styles"
import EventIcon from "@assets/svg/EventIcon.svg?react"
import TextArea from "@Common/Textarea"
import { useMemo, useState } from "react"
import {
	IGetMasterDataAutomationVariable,
	ITriggerType,
} from "src/services/Automations/GetMasterData/types"
import { Menu, MenuItem } from "@mui/material"
import { FaPlus } from "react-icons/fa6"
import { useFormContext } from "react-hook-form" // Import useFormContext
import CustomSelect from "@Common/CustomSelect"

interface IProcedureSectionProps {
	automationVariable: IGetMasterDataAutomationVariable[]
	triggerType: ITriggerType[]
}

export default function ProcedureSection({
	automationVariable,
	triggerType,
}: IProcedureSectionProps) {
	/* ------------------------------- Local State ------------------------------ */
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	/* ---------------------------------- Hooks --------------------------------- */
	const { t, i18n: { language } } = useTranslation()
	const { setValue, watch } = useFormContext()
	const message = watch("message", "")

	/* -------------------------------- Functions ------------------------------- */
	const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleCloseMenu = () => {
		setAnchorEl(null)
	}

	const handleInsertVariable = (variable: string) => {
		const textarea = document.querySelector(
			"textarea[name='message']"
		) as HTMLTextAreaElement | null
		if (textarea) {
			const start = textarea.selectionStart
			const end = textarea.selectionEnd
			const newText =
				message.substring(0, start) + variable + message.substring(end)
			setValue("message", newText)
			setTimeout(() => {
				textarea.selectionStart = textarea.selectionEnd =
					start + variable.length
				textarea.focus()
			}, 0)
		}
		handleCloseMenu()
	}

	const triggerTypeList = useMemo(() => {
		const listOfData = triggerType?.map((item) => {
			return {
				label: language === "ar" ? item.description : item.descriptionEn,
				value: item.id.toString(),
			}
		})
		return listOfData ?? []
	}, [triggerType, language])

	return (
		<ProcedureSectionWrapper>
			<HeaderLabel
				icons={<EventIcon />}
				label={t("AutomationCentre.procedure")}
				tooltip='test'
			/>
			<div>
				<div className='lastSection'>
					<div className='containerGuestLogin'>
						<CustomSelect
							data={triggerTypeList}
							name='triggerType'
							registerOptions={{
								required: {
									value: true,
									message: t("COMMON.REQUIRED"),
								},
							}}
						/>

						<div className='bodyGuestLogin'>
							<TextArea
								name='message'
								label={t("AutomationCentre.message_details")}
								placeholder={t("AutomationCentre.message_placeholder")}
								withOutErrorMessage
								registerOptions={{
									required: {
										value: true,
										message: t("COMMON.REQUIRED"),
									},
								}}
							/>
						</div>
					</div>
					<div className='AutomationCentreAddVariable'>
						<button onClick={handleOpenMenu} type="button">
							<span>
								<FaPlus />
							</span>
							<span>{t("AutomationCentre.add_variable")}</span>
						</button>

						<Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
							{automationVariable.map((variable) => (
								<MenuItem
									key={variable.key}
									onClick={() => handleInsertVariable(variable.key)}
								>
									{language === "ar" ? variable.label : variable.labelEn}
								</MenuItem>
							))}
						</Menu>
					</div>
				</div>
			</div>
		</ProcedureSectionWrapper>
	)
}
